import { useMutation } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { requestDeleteProductVariant } from "./deleteProductVariant.request";

const useDeleteProductVariant = (
  options?: MutationOptions<void, ApiServiceError<ApiError>>
) => {
  return useMutation({
    mutationFn: requestDeleteProductVariant,
    onError: toastServerError,
    ...options
  });
};

export default useDeleteProductVariant;
